export default __webpack_public_path__ + "static/images/logo-4dbdc8737cffc047ea4b2bde75c09572.png";